import React from 'react';
import pt from 'prop-types';

const TalentAward = ({ year, className, trackingId }) => {
  if (!year) {
    return null;
  }

  // If year is equal or greater than 2023, use student award logo
  return year >= 2023 ? (
    <svg
      viewBox="0 0 398.47 141.73"
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
          <style type="text/css">
            .st0{fill:#FFFFFF;}
            .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EC1D26;}
            .cls-34{font-size:27px;font-family:Frutiger;font-weight:400;fill:white}
          </style>
          <rect x="-0.17" class="st0" width="398.02" height="141.73"/>
          <rect ${
            trackingId && 'id="badge_red"'
          } x="6.57" y="6.75" class="st1" width="128.23" height="128.24"/>
            <g>
              <path class="st0" d="M33.61,107.99h20.25V60.74H33.61V107.99z M43.69,32.4c-6.34,0-11.47,5.14-11.47,11.47
                c0,6.34,5.14,11.47,11.47,11.47c6.34,0,11.47-5.14,11.47-11.47C55.17,37.53,50.03,32.4,43.69,32.4z M87.57,33.74v20.25h20.25V33.74
                H87.57z M60.57,107.99h20.25V33.74H60.57V107.99z M87.57,80.99h20.25V60.74H87.57V80.99z"/>
            </g>
          <rect x="141.56" y="6.75" class="st1" width="248.31" height="128.24"/>
          <g>
            <path class="st0" d="M164.38,33.9c6.14,0,10.71,2.58,10.71,9.66c0,6.69-4.71,9.49-10.71,9.49h-4.97V33.9H164.38z M163.07,50.11
              h0.96c4.03,0,7.25-1.67,7.25-6.58c0-5.16-3.22-6.61-7.25-6.61h-0.96V50.11z"/>
            <path class="st0" d="M178.52,33.9h10.74v3.18h-7.12v4.61h6.55v3.1h-6.55v5.05h7.2v3.21h-10.82V33.9z"/>
            <path class="st0" d="M202.75,37.38c-1.43-0.6-2.57-0.82-3.69-0.82c-1.92,0-3.15,0.85-3.15,2.17c0,1.18,0.6,1.92,3.28,2.94
              c3.38,1.26,4.81,2.91,4.81,5.73c0,3.68-2.65,5.98-6.84,5.98c-1.74,0-3.3-0.27-4.81-0.82l0.34-3.37c1.56,0.8,2.99,1.1,4.26,1.1
              c1.92,0,3.3-0.85,3.3-2.39c0-1.45-0.75-2.22-3.51-3.29c-3.22-1.23-4.6-2.77-4.6-5.49c0-3.4,2.63-5.54,6.5-5.54
              c1.61,0,2.96,0.19,4.39,0.69L202.75,37.38z"/>
            <path class="st0" d="M207.33,33.9h3.67v19.15h-3.67V33.9z"/>
            <path class="st0" d="M229.48,37.87c-1.12-0.6-2.94-1.07-4.81-1.07c-3.85,0-6.34,2.55-6.34,6.61c0,3.98,2.26,6.64,6.27,6.64
              c0.75,0,1.56-0.08,2.13-0.27v-4.77h-3.87v-3.07h7.36v10.29c-1.95,0.71-4.03,1.02-6.11,1.02c-5.56,0-9.7-3.73-9.7-9.85
              c0-5.95,4-9.68,10.3-9.68c1.79,0,3.56,0.19,5.04,0.74L229.48,37.87z"/>
            <path class="st0" d="M246.17,33.9h3.3v19.15h-4.63l-4.65-9.38c-0.94-1.89-2.13-4.64-2.63-5.9h-0.05c0.08,1.18,0.13,4.69,0.13,6.34
              v8.94h-3.3V33.9h4.89l4.58,9.46c0.68,1.37,1.92,4.25,2.47,5.6h0.05c-0.08-1.4-0.16-5.1-0.16-7.02V33.9z"/>
          </g>
          <g ${trackingId && 'id="Talent"'}>
            <path class="st0" d="M169.13,65.22c-1.43-0.6-2.57-0.82-3.69-0.82c-1.92,0-3.15,0.85-3.15,2.17c0,1.18,0.6,1.92,3.28,2.94
              c3.38,1.26,4.81,2.91,4.81,5.73c0,3.68-2.65,5.98-6.84,5.98c-1.74,0-3.3-0.27-4.81-0.82l0.34-3.37c1.56,0.79,2.99,1.1,4.26,1.1
              c1.92,0,3.3-0.85,3.3-2.39c0-1.45-0.75-2.22-3.51-3.29c-3.22-1.23-4.6-2.77-4.6-5.49c0-3.4,2.63-5.54,6.5-5.54
              c1.61,0,2.96,0.19,4.39,0.69L169.13,65.22z"/>
            <path class="st0" d="M185.77,64.98l-5.07-0.08v15.99h-3.72V64.89l-4.97,0.08v-3.24h13.75V64.98z"/>
            <path class="st0" d="M192.06,61.74v11.27c0,3.57,1.17,5.1,3.67,5.1c2.7,0,3.9-1.54,3.9-5.1V61.74h3.51v11.55
              c0,5.24-2.55,7.93-7.44,7.93c-5.2,0-7.33-2.69-7.33-7.93V61.74H192.06z"/>
            <path class="st0" d="M212.4,61.74c6.14,0,10.71,2.58,10.71,9.66c0,6.69-4.71,9.49-10.71,9.49h-4.97V61.74H212.4z M211.1,77.95h0.96
              c4.03,0,7.25-1.67,7.25-6.58c0-5.16-3.22-6.61-7.25-6.61h-0.96V77.95z"/>
            <path class="st0" d="M226.54,61.74h10.74v3.18h-7.12v4.61h6.55v3.1h-6.55v5.05h7.2v3.21h-10.82V61.74z"/>
            <path class="st0" d="M252.98,61.74h3.3v19.15h-4.63L247,71.51c-0.94-1.89-2.13-4.64-2.63-5.9h-0.05c0.08,1.18,0.13,4.69,0.13,6.34
              v8.94h-3.3V61.74h4.89l4.58,9.46c0.68,1.37,1.92,4.25,2.47,5.6h0.05c-0.08-1.4-0.16-5.1-0.16-7.02V61.74z"/>
            <path class="st0" d="M272.72,64.98l-5.07-0.08v15.99h-3.72V64.89l-4.97,0.08v-3.24h13.75V64.98z"/>
            <path class="st0" d="M298.33,80.89h-3.98l-1.59-4.42h-7.57l-1.59,4.42h-3.77l7.12-19.15h4.13L298.33,80.89z M290.27,69.09
              c-0.39-1.15-1.01-3.35-1.25-4.33h-0.05c-0.26,0.99-0.94,3.18-1.33,4.33l-1.51,4.47h5.64L290.27,69.09z"/>
            <path class="st0" d="M311.64,68.08c-0.18-0.88-0.55-2.55-0.68-3.59h-0.05c-0.13,1.04-0.42,2.69-0.6,3.59l-2.7,12.81h-4.63
              l-5.02-19.15h3.93l2.63,11.47c0.13,0.63,0.7,3.4,0.86,4.69h0.05c0.18-1.29,0.7-4.06,0.83-4.69l2.37-11.47h4.86l2.5,11.47
              c0.16,0.66,0.65,3.43,0.83,4.69h0.05c0.18-1.26,0.7-3.98,0.86-4.69l2.6-11.47h3.64l-4.86,19.15h-4.6L311.64,68.08z"/>
            <path class="st0" d="M342.19,80.89h-3.98l-1.59-4.42h-7.57l-1.59,4.42h-3.77l7.12-19.15h4.13L342.19,80.89z M334.13,69.09
              c-0.39-1.15-1.01-3.35-1.25-4.33h-0.05c-0.26,0.99-0.94,3.18-1.33,4.33l-1.51,4.47h5.64L334.13,69.09z"/>
            <path class="st0" d="M344.76,61.74h5.25c4.47,0,7.44,1.01,7.44,5.02c0,2.52-1.43,4.03-3.8,4.53v0.05c1.27,0.36,1.74,1.12,2.31,2.55
              l2.81,7h-4.03l-2.03-5.43c-0.75-2-1.09-2.52-3.33-2.52h-0.96v7.96h-3.67V61.74z M348.43,69.97h1.07c2.89,0,4.19-0.77,4.19-2.69
              c0-2.08-1.56-2.52-4.19-2.52h-1.07V69.97z"/>
            <path class="st0" d="M366.16,61.74c6.14,0,10.71,2.58,10.71,9.66c0,6.69-4.71,9.49-10.71,9.49h-4.97V61.74H366.16z M364.86,77.95
              h0.96c4.03,0,7.25-1.67,7.25-6.58c0-5.16-3.22-6.61-7.25-6.61h-0.96V77.95z"/>
          </g>
          <text class="cls-34" ${
            trackingId && 'id="Award_Year"'
          } transform="translate(157 109)">${year}</text>
          </g>
        `,
      }}
    ></svg>
  ) : (
    <svg
      viewBox="0 0 727.1 256.5"
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
          <defs>
            <style>
              ${`.cls-14{fill:#ec1d26}.cls-24,.cls-34{fill:#fff}.cls-34{font-size:56.4px;font-family:Frutiger;font-weight:400;}`}
            </style>
          </defs>
          <path class="cls-24" d="M0 0h727.1v256.5H0z"/>
          <path class="cls-14" ${
            trackingId && 'id="badge_red"'
          } d="M13.27 13.27h243.2v230.5H13.27z"/>
          <path class="cls-24" d="M67.6 216h40.5v-94.5H67.6ZM87.7 64.8a23 23 0 1 0 23 23 22.92 22.92 0 0 0-23-23Zm87.8 2.7V108H216V67.5Zm-54 148.5H162V67.5h-40.5Zm54-54H216v-40.5h-40.5Z" transform="translate(-13.5 -13.5)"/>
          <path class="cls-14" d="M270 13.27h443.8v230.5H270z"/>
          <path class="cls-24" ${
            trackingId && 'id="Talent"'
          } d="M328.3 67.6c12.4 0 21.6 5.2 21.6 19.5 0 13.5-9.5 19.1-21.6 19.1h-10V67.6Zm-2.6 32.7h1.9c8.1 0 14.6-3.4 14.6-13.3 0-10.4-6.5-13.3-14.6-13.3h-1.9ZM356.9 67.6h21.6V74h-14.3v9.3h13.2v6.2h-13.2v10.2h14.5v6.5h-21.8ZM405.9 74.6a17.31 17.31 0 0 0-7.4-1.6c-3.9 0-6.3 1.7-6.3 4.4 0 2.4 1.2 3.9 6.6 5.9 6.8 2.5 9.7 5.9 9.7 11.6 0 7.4-5.3 12.1-13.8 12.1a26.8 26.8 0 0 1-9.7-1.7l.7-6.8a18.32 18.32 0 0 0 8.6 2.2c3.9 0 6.7-1.7 6.7-4.8 0-2.9-1.5-4.5-7.1-6.6-6.5-2.5-9.3-5.6-9.3-11 0-6.9 5.3-11.2 13.1-11.2a24.75 24.75 0 0 1 8.9 1.4ZM415 67.6h7.4v38.6H415ZM459.6 75.6a21.55 21.55 0 0 0-9.7-2.2c-7.8 0-12.8 5.1-12.8 13.3 0 8 4.6 13.4 12.6 13.4a15.4 15.4 0 0 0 4.3-.6V90h-7.8v-6.2H461v20.7a34.5 34.5 0 0 1-12.3 2c-11.2 0-19.5-7.5-19.5-19.8 0-12 8.1-19.5 20.8-19.5a29.36 29.36 0 0 1 10.2 1.5ZM494 67.6h6.7v38.6h-9.3L482 87.3c-1.9-3.8-4.3-9.3-5.3-11.9h-.1c.2 2.4.3 9.4.3 12.8v18h-6.6V67.6h9.8l9.2 19.1c1.4 2.8 3.9 8.6 5 11.3h.1c-.2-2.8-.3-10.3-.3-14.2ZM342.6 129l-10.2-.2V161h-7.5v-32.2l-10 .2v-6.5h27.7ZM376.9 161.1h-8l-3.2-8.9h-15.3l-3.2 8.9h-7.6l14.3-38.6h8.3Zm-16.2-23.8c-.8-2.3-2-6.8-2.5-8.7h-.1c-.5 2-1.9 6.4-2.7 8.7l-3 9h11.4ZM381.9 122.5h7.4v32h14.2v6.6h-21.6ZM408.8 122.5h21.6v6.4H416v9.3h13.2v6.2H416v10.2h14.5v6.5h-21.8v-38.6ZM462 122.5h6.6v38.6h-9.3l-9.3-18.9c-1.9-3.8-4.3-9.3-5.3-11.9h-.1c.1 2.4.3 9.5.3 12.8v18h-6.7v-38.6h9.8l9.2 19.1c1.4 2.8 3.9 8.6 5 11.3h.1c-.2-2.8-.3-10.3-.3-14.1ZM501.8 129l-10.2-.2V161H484v-32.2l-10 .2v-6.5h27.7ZM551.3 161.1h-8l-3.2-8.9h-15.3l-3.2 8.9H514l14.3-38.6h8.3ZM535 137.3c-.8-2.3-2-6.8-2.5-8.7h-.1c-.5 2-1.9 6.4-2.7 8.7l-3 9h11.4ZM579.2 135.3c-.4-1.8-1.1-5.1-1.4-7.2h-.1c-.3 2.1-.8 5.4-1.2 7.2l-5.5 25.8h-9.3l-10.1-38.6h7.9l5.3 23.1c.3 1.3 1.4 6.9 1.7 9.5h.1c.4-2.6 1.4-8.2 1.7-9.5l4.8-23.1h9.8l5 23.1c.3 1.3 1.3 6.9 1.7 9.5h.1c.4-2.6 1.4-8 1.7-9.5l5.2-23.1h7.3l-9.8 38.6H585ZM641.6 161.1h-8l-3.2-8.9h-15.3l-3.2 8.9h-7.6l14.4-38.6h8.3Zm-16.3-23.8c-.8-2.3-2-6.8-2.5-8.7h-.1c-.5 2-1.9 6.4-2.7 8.7l-3 9h11.4ZM646.5 122.5h10.6c9 0 15 2 15 10.1 0 5.1-2.9 8.1-7.7 9.1v.1c2.6.7 3.5 2.3 4.7 5.1l5.7 14.1h-8.1l-4.1-10.9c-1.5-4-2.2-5.1-6.7-5.1H654v16h-7.4Zm7.4 16.6h2.1c5.8 0 8.4-1.6 8.4-5.4 0-4.2-3.1-5.1-8.4-5.1h-2.2ZM689.1 122.5c12.4 0 21.6 5.2 21.6 19.5 0 13.5-9.5 19.1-21.6 19.1h-10v-38.6Zm-2.6 32.7h1.9c8.1 0 14.6-3.4 14.6-13.3 0-10.4-6.5-13.3-14.6-13.3h-1.9Z" transform="translate(-13.5 -13.5)"/>
          <text class="cls-34" ${
            trackingId && 'id="Award_Year"'
          } transform="translate(300.44 201.52)">${year}</text>
        `,
      }}
    />
  );
};

TalentAward.propTypes = {
  year: pt.number.isRequired,
  className: pt.string,
  trackingId: pt.bool,
};

TalentAward.defaultProps = {
  className: '',
};

export default TalentAward;
